"use client";

import { Disclosure } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { motion } from "framer-motion";

const service = [
  { title: "Professional photography" },
  { title: "Creative Director" },
  { title: "Writer" },
  { title: "Journalist" },
];

export default function Services() {
  return (
    <div className="relative w-full items-center justify-center">
      <section className="items-center">
        <motion.h3
          initial={{ y: 48, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ ease: "easeInOut", duration: 0.75 }}
          className="mb-5 text-2xl font-black uppercase text-zinc-50 text-center"
        >
          What I Do
        </motion.h3>{" "}
      </section>
      <section className=" max-w-5xl mx-auto py-12 px-6 md:px-12 flex flex-col md:flex-row gap-8">
        <div className="w-full space-y-4">
          {service.map((service, index) => (
            <Disclosure key={index}>
              <div>
                <div className="flex justify-between w-full py-3 border-b border-gray-300 text-left font-medium">
                  {service.title}
                  {/* <ChevronRightIcon
                    className={`w-5 h-5 transition-transform`}
                  /> */}
                </div>
              </div>
            </Disclosure>
          ))}
        </div>
      </section>
    </div>
  );
}
